import { AccompanimentById } from "../modules";

export const AccompanimentByIdPage = () => {
  return (
    <>
      <AccompanimentById />
    </>
  );
};
